jQuery(document).ready(function() {
	//sticky-header

	// jQuery(window).scroll(function(){
	// 	var sticky = jQuery('.site-header'),
	// 		scroll = jQuery(window).scrollTop();
	
	// 	if (scroll >= 300) sticky.addClass('nav-fixed');
	// 	else sticky.removeClass('nav-fixed');
	// });

	jQuery('.header__modal-open-button').on('click', function(){

		jQuery(".mobile_menu--wrapper").addClass('menu-isOpen');
		jQuery('body').append('<div class="menu_overlay_mobile"></div>');
		jQuery("body").addClass('side-menu-open');
		jQuery(this).parent().addClass("is--active");
	});
	jQuery('.header__modal-close-button').on('click', function(){
		jQuery('.menu_overlay_mobile').remove();
		jQuery(".mobile_menu--wrapper").removeClass('menu-isOpen');
		jQuery("body").removeClass('side-menu-open');
		jQuery(this).parent().removeClass("is--active");

	});

	jQuery('#main_menu #menu-accordion-icon').on('click', function(){
		jQuery(this).parent().find('.menu_dropdown-menu').slideToggle();
		jQuery(this).parent().find('ul.child_menu').slideToggle();
		jQuery(this).toggleClass("isClosed isOpen");
	});

	
	jQuery('#top_shipping_slider').slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
	});
	
    jQuery("#slider_banner").owlCarousel({
		items:1,
		loop:true,
		nav:false,
		dots:false,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		slideSpeed: 300,
    });
	jQuery("#featured_in_logos").owlCarousel({
		navigation : true,
		items:8,
		margin:64,
		autoWidth:true,
		loop:true,
		dots:false,
		nav:false,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:4,
				dots:false,
				margin:24,
			},
			992:{
				margin:40,
			},
			1440:{
				margin:64,
				items:10,
			}
		}
	});

	// Check screen width on page load
	// var screenWidth = jQuery(window).width();
	// if(screenWidth > 767){
	// 	jQuery(".product__media-mobile-wrapper, .mobile_sort--filter, .mobile-filter__header, .mobile_filter-drawer").remove();
	// }
	// if(screenWidth < 768){
	// 	jQuery(".floated_product--form, .collection_actions, .product__media-desktop-wrapper").remove();
	// }

	jQuery(".related_products-Slider").owlCarousel({
		navigation : true,
		margin:8,
		items:3,
		loop:true,
		dots:false,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1,
				dots:false,
			},
			481:{
				items:2,
			},
			576:{
				items:3,
			},
			768:{
				items:1,
			},
			980:{
				items:2,
				margin:8,
			},
			1200:{
				dots:false,
				items:3,
				margin:12,
			}
		}
	});

	jQuery(".recommended_products-Slider").owlCarousel({
		navigation : false,
		margin:8,
		items:6,
		loop:true,
		dots:false,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1,
				dots:false,
			},
			481:{
				items:2,
			},
			576:{
				items:3,
			},
			768:{
				items:3,
			},
			992:{
				items:4,
			},
			1200:{
				dots:false,
				items:5,
				margin:8,
			},
			1367:{
				dots:false,
				items:6,
				margin:12,
			}
		}
	});

	jQuery('.pdp-images-main-slider').slick({
        dots:false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.pdp-images-nav-slider',
		infinite: false,
    }); 
	
	jQuery('.pdp-images-nav-slider').slick({
		arrows: true,
		infinite: false,
		dots:false,
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.pdp-images-main-slider',
		vertical: true,
        verticalSwiping: true,
    	verticalScrolling: true,
		focusOnSelect: true,
		responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				vertical: false,
    			verticalScrolling: true,
			  }
			},
		  ]
	}); 



  jQuery(".featured_products-Slider").owlCarousel({
		navigation : true,
		margin:8,
		items:4,
		loop:true,
		dots:false,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1,
				dots:false,
			},
			481:{
				items:2,
			},
			576:{
				items:3,
			},
			768:{
				items:1,
			},
			980:{
				items:2,
				margin:8,
			},
			1200:{
				dots:false,
              	nav:true,
				items:4,
				margin:12,
			}
		}
	});


    jQuery(".reviews-slider").owlCarousel({
		navigation : true,
		margin:20,
		items:3,
		loop:true,
		dots:false,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1,
				dots:false,
			},
			481:{
				items:2,
			},
			576:{
				items:3,
			},
			768:{
				items:1,
			},
			980:{
				items:2,
				margin:15,
			},
			1200:{
				dots:false,
				items:3,
				margin:20,
			}
		}
	});

	jQuery('.collection_filter--header').on('click', function(){
		jQuery(this).next().slideToggle();
		jQuery(this).toggleClass('filter_menu_open');
	});

	jQuery('#open_mobile--filter').on('click', function(){
		jQuery('.collection_filter--wrapper').addClass('active');
		jQuery('body').append('<div class="menu_overlay_mobile" style="z-index:999;"></div>');
		jQuery("body").addClass('side-menu-open');
	});
	jQuery('#close_mobile--filter').on('click', function(){
		jQuery('.collection_filter--wrapper').removeClass('active');
		jQuery('.menu_overlay_mobile').remove();
		jQuery("body").removeClass('side-menu-open');
	});

    
    jQuery(".recover-password").click(function() {
      jQuery(".login-form").hide();
      jQuery(".forgot-form").show();
    });
    
    jQuery(".back-login").click(function() {
      jQuery(".login-form").show();
      jQuery(".forgot-form").hide();
    });

    jQuery(".selected_variant").change(function () {
      var vid = jQuery(this).val();
      var selected = $('.selected_variant option[value="'+vid+'"]').data('image-id');
      jQuery('[data-thumbnail="'+selected+'"]').trigger('click');
    });

  jQuery(document).delegate(".qty_plus", "click", function(e) {
        $input = jQuery(this).prev('input');
        var val = parseInt($input.val());
        $input.val( val+1 ).change();
    });
    jQuery(document).delegate(".qty_minus", "click", function(e) {
        $input = jQuery(this).next('input');
        var val = parseInt($input.val());
        if (val > 0) {
            $input.val( val-1 ).change();
        } 
    });

  jQuery('.tab---1').on('click', function(){
    jQuery('.tab--1').show();
    jQuery('.tab--2').hide();
    jQuery('.tab---1').addClass("__selected");
    jQuery('.tab---2').removeClass("__selected");
  });
  jQuery('.tab---2').on('click', function(){
    jQuery('.tab--2').show();
    jQuery('.tab--1').hide();
    jQuery('.tab---2').addClass("__selected");
    jQuery('.tab---1').removeClass("__selected");
  });


  setInterval(function() {
    jQuery('.tab--1').toggle();
    jQuery('.tab--2').toggle();
    // Check visibility and add/remove the __selected class
    if (jQuery('.tab--1').is(':visible')) {
        jQuery('.tab---1').addClass('__selected');
        jQuery('.tab---2').removeClass('__selected');
    } else {
        jQuery('.tab---2').addClass('__selected');
        jQuery('.tab---1').removeClass('__selected');
    }
    
   }, 8000);
  


  jQuery('.open-chat').on('click', function(){
    document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
  });




  

  
	
});